<template>
  <div id="app">
    <video-player />
    <audio-player />

    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="isRouterAlive && !$route.meta.keepAlive"/>
  </div>
</template>

<script>
import AudioPlayer from '@/components/audioPlayer'
import VideoPlayer from '@/components/videoPlayer'
export default {
  components: {
    AudioPlayer,
    VideoPlayer
  },
  data(){
    return {
      isRouterAlive: true,

    }
  },
  created(){

  },
  provide(){
    return{
      reload: this.reload
    }
  },
  methods: {
    reload(){
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },



  },
  beforeDestroy(){

  }
}
</script>

<style lang="less" scoped>
#app {
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
